<template>
  <span>
    <slot :loading="loading" :on="{ click: exportServiceRecords }">
      <v-btn
        light
        class="mx-1"
        :loading="loading"
        @click="exportServiceRecords"
      >
        EXPORT
      </v-btn>
    </slot>
  </span>
</template>

<script>
import moment from "moment-timezone";
import { MissionAssetService } from "@/services/missionAsset.service";

export default {
  props: {
    params: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    loading: false
  }),
  methods: {
    async exportServiceRecords() {
      this.loading = true;

      try {
        const data = await MissionAssetService.export(
          {
            ...this.params,
            download: 1,
            timezone: moment.tz.guess(),
            contract: this.$store.getters['contracts/selected'].name,
          },
          {
            responseType: "blob"
          }
        ).then(response => response.data);

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(data);
        link.download = "service_records.csv";
        link.click();
      } catch (err) {}

      this.loading = false;
    }
  }
};
</script>
